module.exports = __webpack_public_path__ + "static/media/appdev.402e481d.png";